module.exports = __webpack_public_path__ + "img/logo-rdp-white.9fc7907b.svg";